import React from "react";

import styles from "./css/terms-and-conditions.module.css";
import { Container } from "react-bootstrap";
import { Bounce, Fade, Zoom } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import banner from "./images/terms-and-conditions-banner.jpg";
import { useSelector } from "react-redux";
const TermsAndConditions = () => {
  const language = useSelector((state) => state.language.language);
  return (
    <>
      <Helmet>
        <title>
          {language === "en" ? "Terms & Conditions" : "الشروط والاحكام"}
        </title>
      </Helmet>
      <section>
        <div
          className="breadcumb-area d-flex align-items-center"
          style={{
            background: `url(banner-rooms.jpg)`,
          }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="breacumb-content">
                  <Zoom duration="2500">
                    {" "}
                    <div className="breadcum-title">
                      <h4>
                        {language === "en"
                          ? "Terms & Conditions"
                          : "الشروط والاحكام"}
                      </h4>
                    </div>
                  </Zoom>
                  <Fade duration="2500" direction="up">
                    {" "}
                    <ul>
                      <li>
                        <Link to="/" style={{ color: "#fff" }}>
                          {language === "en" ? "Home" : " الرئيسية "}
                        </Link>
                      </li>
                      <li className="px-2"> / </li>
                      <li>
                        {language === "en"
                          ? "Terms & Conditions"
                          : "الشروط والاحكام"}
                      </li>
                    </ul>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="first-section mb-5 pb-5" id="terms">
        <Container>
          <div className="page_content_wrap scheme_default">
            <div className="content_wrap  ">
              <div className="content col-12">
                <div className="col-11 col-lg-12 mx-auto my-5">
                  <h5 className="mt-0">
                    {language === "en"
                      ? "Terms & Conditions"
                      : "الشروط والاحكام"}
                  </h5>
                  <p>
                    {language === "en"
                      ? ` Please read these terms and conditions carefully before
                  using Our Service.`
                      : ` يرجى قراءة هذه الشروط والأحكام بعناية قبل استخدام خدمتنا. `}
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto my-5">
                  <h5 className="mt-0">
                    {language === "en"
                      ? ` Interpretation and Definitions`
                      : `التفسير والتعاريف `}
                  </h5>
                  <h6 className="my-3">
                    <span style={{ fontWeight: "400" }}>
                      {language === "en" ? ` Interpretation` : `التفسير   `}
                    </span>
                  </h6>
                  <p>
                    {language === "en"
                      ? `The words of which the initial letter is capitalized have
                  meanings defined under the following conditions. The
                  following definitions shall have the same meaning regardless
                  of whether they appear in singular or in plural.`
                      : `الكلمات التي يتم كتابة الحرف الأول منها بالأحرف الكبيرة لها معاني محددة وفقًا للشروط التالية. يكون للتعريفات التالية نفس المعنى بغض النظر عما إذا كانت تظهر بصيغة المفرد أو الجمع.`}
                  </p>
                  <h6 className="my-3">
                    <span style={{ fontWeight: "400" }}>
                      {language === "en" ? `  Definitions` : `  التعاريف `}
                    </span>
                  </h6>
                  <p className="text-dark my-0" style={{ fontWeight: "500" }}>
                    {language === "en"
                      ? "For the purposes of these Terms and Conditions:"
                      : "لأغراض هذه الشروط والأحكام:"}
                  </p>
                  <p className="ps-4 my-1" style={{ fontWeight: "400" }}>
                    <span className="text-dark" style={{ fontWeight: "500" }}>
                      {language === "en" ? "Affiliate" : "انضم"}
                    </span>{" "}
                    {language === "en"
                      ? `means an entity that controls, is controlled by or is under
                    common control with a party, where "control" means ownership
                    of 50% or more of the shares, equity interest or other
                    securities entitled to vote for election of directors or
                    other managing authority.`
                      : `مصطلح يشير إلى كيان يسيطر أو يخضع لسيطرة أو يخضع لسيطرة مشتركة مع طرف ما، حيث تعني كلمة "السيطرة" ملكية 50% أو أكثر من الأسهم أو حقوق الملكية أو الأوراق المالية الأخرى التي يحق لها التصويت لانتخاب أعضاء مجلس الإدارة أو أي سلطة إدارية أخرى.`}
                  </p>
                  <p className="ps-4 my-1" style={{ fontWeight: "400" }}>
                    <span className="text-dark" style={{ fontWeight: "500" }}>
                      {language === "en" ? "Country" : "دولة"}
                    </span>{" "}
                    {language === "en" ? " refers to: Egypt" : "يشير إلى: مصر"}
                  </p>
                  <p className="ps-4 my-1" style={{ fontWeight: "400" }}>
                    <span className="text-dark" style={{ fontWeight: "500" }}>
                      {language === "en" ? "Company" : "شركة"}{" "}
                    </span>
                    {language === "en"
                      ? `(referred to as either "the Company", "We", "Us" or "Our" in
                    this Agreement) refers to Nile Capital Cruisess, Behind
                    Sharm Dreams Resort – Naama Bay – Sharm El-SHEIKH, Egypt.`
                      : `(يشار إليها إما بـ "الشركة" أو "نحن" أو "نا" أو "خاصتنا" في هذه الاتفاقية) تشير إلى شركة نايل كابيتال للرحلات النيلية، خلف منتجع شرم دريمز – خليج نعمة – شرم الشيخ، مصر.`}
                  </p>
                  <p className="ps-4 my-1" style={{ fontWeight: "400" }}>
                    <span className="text-dark" style={{ fontWeight: "500" }}>
                      {language === "en" ? "Device" : "جهاز"}
                    </span>{" "}
                    {language === "en"
                      ? `means any device that can access the Service such as a
                    computer, a cellphone or a digital tablet.`
                      : `يعني أي جهاز يمكنه الوصول إلى الخدمة مثل جهاز كمبيوتر أو هاتف محمول أو جهاز لوحي رقمي.`}
                  </p>
                  <p className="ps-4 my-1" style={{ fontWeight: "400" }}>
                    <span className="text-dark" style={{ fontWeight: "500" }}>
                      {language === "en" ? "Service" : "خدمة"}
                    </span>{" "}
                    {language === "en"
                      ? "refers to the Website."
                      : "يشير إلى الموقع."}
                  </p>
                  <p className="ps-4 my-1" style={{ fontWeight: "400" }}>
                    <span className="text-dark" style={{ fontWeight: "500" }}>
                      {language === "en"
                        ? "Terms and Conditions"
                        : " الشروط والأحكام "}
                    </span>
                    {language === "en"
                      ? `(also referred as "Terms") mean these Terms and Conditions
                    that form the entire agreement between You and the Company
                    regarding the use of the Service. This Terms and Conditions
                    agreement has been created with the help of the Terms and
                    Conditions Generator.`
                      : `(يشار إليها أيضًا باسم "الشروط") تعني هذه الشروط والأحكام التي تشكل الاتفاقية الكاملة بينك وبين الشركة فيما يتعلق باستخدام الخدمة. تم إنشاء اتفاقية الشروط والأحكام هذه بمساعدة منشئ الشروط والأحكام.`}
                  </p>
                  <p className="ps-4 my-1" style={{ fontWeight: "400" }}>
                    <span className="text-dark" style={{ fontWeight: "500" }}>
                      {language === "en"
                        ? " Third-party Social Media Service"
                        : "خدمة الوسائط الاجتماعية لطرف ثالث"}
                    </span>{" "}
                    {language === "en"
                      ? ` means any services or content (including data, information,
                      products or services) provided by a third-party that may be
                      displayed, included or made available by the Service.`
                      : `يعني أي خدمات أو محتوى (بما في ذلك البيانات أو المعلومات أو المنتجات أو الخدمات) يقدمها طرف ثالث والتي قد يتم عرضها أو تضمينها أو إتاحتها بواسطة الخدمة.`}
                  </p>
                  <p className="ps-4 my-1" style={{ fontWeight: "400" }}>
                    <span className="text-dark" style={{ fontWeight: "500" }}>
                      {language === "en" ? "Website" : "الموقع"}
                    </span>{" "}
                    {language === "en"
                      ? "refers to Nile Capital Cruisess, accessible from "
                      : " يشير إلى نايل كابيتال للرحلات النيلية، ويمكن الوصول إليه من"}
                    <Link to="/" target="_blank" rel="noopener">
                      {" "}
                      <span style={{ fontWeight: "400" }}>
                        <u>https://nilecapitalcruises.com</u>
                      </span>
                    </Link>
                  </p>
                  <p className="ps-4 my-1" style={{ fontWeight: "400" }}>
                    <span className="text-dark" style={{ fontWeight: "500" }}>
                      {language === "en" ? "You" : "أنت"}
                    </span>{" "}
                    {language === "en"
                      ? `means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.`
                      : `مصطلح يشير إلى الفرد الذي يصل إلى الخدمة أو يستخدمها، أو الشركة أو أي كيان قانوني آخر يقوم هذا الفرد بالنيابة عنه بالوصول إلى الخدمة أو استخدامها، حسب الاقتضاء.`}
                  </p>
                </div>
                <hr className={`${styles.hr}`} />

                <div className="col-11 col-lg-12 mx-auto  my-5">
                  <h5 className="mt-0">Acknowledgment</h5>
                  <p className="my-2">
                    These are the Terms and Conditions governing the use of this
                    Service and the agreement that operates between You and the
                    Company. These Terms and Conditions set out the rights and
                    obligations of all users regarding the use of the Service.
                  </p>
                  <p className="my-2">
                    Your access to and use of the Service is conditioned on Your
                    acceptance of and compliance with these Terms and
                    Conditions. These Terms and Conditions apply to all
                    visitors, users and others who access or use the Service.
                  </p>
                  <p className="my-2">
                    By accessing or using the Service You agree to be bound by
                    these Terms and Conditions. If You disagree with any part of
                    these Terms and Conditions then You may not access the
                    Service.
                  </p>
                  <p className="my-2">
                    You represent that you are over the age of 18. The Company
                    does not permit those under 18 to use the Service.
                  </p>
                  <p className="my-2">
                    Your access to and use of the Service is also conditioned on
                    Your acceptance of and compliance with the Privacy Policy of
                    the Company. Our Privacy Policy describes Our policies and
                    procedures on the collection, use and disclosure of Your
                    personal information when You use the Application or the
                    Website and tells You about Your privacy rights and how the
                    law protects You. Please read Our Privacy Policy carefully
                    before using Our Service.
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto  my-5">
                  <h5 className="mt-0">Links to Other Websites</h5>
                  <p className="my-2">
                    Our Service may contain links to third-party web sites or
                    services that are not owned or controlled by the Company.
                  </p>
                  <p className="my-2">
                    The Company has no control over, and assumes no
                    responsibility for, the content, privacy policies, or
                    practices of any third party web sites or services. You
                    further acknowledge and agree that the Company shall not be
                    responsible or liable, directly or indirectly, for any
                    damage or loss caused or alleged to be caused by or in
                    connection with the use of or reliance on any such content,
                    goods or services available on or through any such web sites
                    or services.
                  </p>
                  <p className="my-2">
                    We strongly advise You to read the terms and conditions and
                    privacy policies of any third-party web sites or services
                    that You visit.
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto  my-5">
                  <h5 className="mt-0">Termination</h5>
                  <p className="my-2">
                    We may terminate or suspend Your access immediately, without
                    prior notice or liability, for any reason whatsoever,
                    including without limitation if You breach these Terms and
                    Conditions.
                  </p>

                  <p className="my-2">
                    Upon termination, Your right to use the Service will cease
                    immediately.
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto  my-5">
                  <h5 className="mt-0"> Limitation of Liability</h5>
                  <p className="my-2">
                    Notwithstanding any damages that You might incur, the entire
                    liability of the Company and any of its suppliers under any
                    provision of this Terms and Your exclusive remedy for all of
                    the foregoing shall be limited to the amount actually paid
                    by You through the Service or 100 USD if You haven't
                    purchased anything through the Service.
                  </p>

                  <p className="my-2">
                    To the maximum extent permitted by applicable law, in no
                    event shall the Company or its suppliers be liable for any
                    special, incidental, indirect, or consequential damages
                    whatsoever (including, but not limited to, damages for loss
                    of profits, loss of data or other information, for business
                    interruption, for personal injury, loss of privacy arising
                    out of or in any way related to the use of or inability to
                    use the Service, third-party software and/or third-party
                    hardware used with the Service, or otherwise in connection
                    with any provision of this Terms), even if the Company or
                    any supplier has been advised of the possibility of such
                    damages and even if the remedy fails of its essential
                    purpose.
                  </p>
                  <p className="my-2">
                    Some states do not allow the exclusion of implied warranties
                    or limitation of liability for incidental or consequential
                    damages, which means that some of the above limitations may
                    not apply. In these states, each party's liability will be
                    limited to the greatest extent permitted by law.
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto  my-5">
                  <h5 className="mt-0">
                    "AS IS" and "AS AVAILABLE" Disclaimer
                  </h5>
                  <p className="my-2">
                    The Service is provided to You "AS IS" and "AS AVAILABLE"
                    and with all faults and defects without warranty of any
                    kind. To the maximum extent permitted under applicable law,
                    the Company, on its own behalf and on behalf of its
                    Affiliates and its and their respective licensors and
                    service providers, expressly disclaims all warranties,
                    whether express, implied, statutory or otherwise, with
                    respect to the Service, including all implied warranties of
                    merchantability, fitness for a particular purpose, title and
                    non-infringement, and warranties that may arise out of
                    course of dealing, course of performance, usage or trade
                    practice. Without limitation to the foregoing, the Company
                    provides no warranty or undertaking, and makes no
                    representation of any kind that the Service will meet Your
                    requirements, achieve any intended results, be compatible or
                    work with any other software, applications, systems or
                    services, operate without interruption, meet any performance
                    or reliability standards or be error free or that any errors
                    or defects can or will be corrected.
                  </p>

                  <p className="my-2">
                    Without limiting the foregoing, neither the Company nor any
                    of the company's provider makes any representation or
                    warranty of any kind, express or implied: (i) as to the
                    operation or availability of the Service, or the
                    information, content, and materials or products included
                    thereon; (ii) that the Service will be uninterrupted or
                    error-free; (iii) as to the accuracy, reliability, or
                    currency of any information or content provided through the
                    Service; or (iv) that the Service, its servers, the content,
                    or e-mails sent from or on behalf of the Company are free of
                    viruses, scripts, trojan horses, worms, malware, timebombs
                    or other harmful components.
                  </p>
                  <p className="my-2">
                    Some jurisdictions do not allow the exclusion of certain
                    types of warranties or limitations on applicable statutory
                    rights of a consumer, so some or all of the above exclusions
                    and limitations may not apply to You. But in such a case the
                    exclusions and limitations set forth in this section shall
                    be applied to the greatest extent enforceable under
                    applicable law.
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto  my-5">
                  <h5 className="mt-0">Governing Law</h5>
                  <p className="my-2">
                    The laws of the Country, excluding its conflicts of law
                    rules, shall govern this Terms and Your use of the Service.
                    Your use of the Application may also be subject to other
                    local, state, national, or international laws.
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto  my-5">
                  <h5 className="mt-0">Disputes Resolution</h5>
                  <p className="my-2">
                    If You have any concern or dispute about the Service, You
                    agree to first try to resolve the dispute informally by
                    contacting the Company.
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto  my-5">
                  <h5 className="mt-0">For European Union (EU) Users</h5>
                  <p className="my-2">
                    If You are a European Union consumer, you will benefit from
                    any mandatory provisions of the law of the country in which
                    you are resident in.
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto  my-5">
                  <h5 className="mt-0">United States Legal Compliance</h5>
                  <p className="my-2">
                    You represent and warrant that (i) You are not located in a
                    country that is subject to the United States government
                    embargo, or that has been designated by the United States
                    government as a "terrorist supporting" country, and (ii) You
                    are not listed on any United States government list of
                    prohibited or restricted parties.
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto my-5">
                  <h5 className="mt-0">Severability and Waiver</h5>
                  <h6 className="my-3">
                    <span style={{ fontWeight: "400" }}>Severability</span>
                  </h6>
                  <p>
                    If any provision of these Terms is held to be unenforceable
                    or invalid, such provision will be changed and interpreted
                    to accomplish the objectives of such provision to the
                    greatest extent possible under applicable law and the
                    remaining provisions will continue in full force and effect.
                  </p>
                  <h6 className="my-3">
                    <span style={{ fontWeight: "400" }}>Waiver</span>
                  </h6>
                  <p>
                    Except as provided herein, the failure to exercise a right
                    or to require performance of an obligation under these Terms
                    shall not effect a party's ability to exercise such right or
                    require such performance at any time thereafter nor shall
                    the waiver of a breach constitute a waiver of any subsequent
                    breach.
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto  my-5">
                  <h5 className="mt-0">Translation Interpretation</h5>
                  <p className="my-2">
                    These Terms and Conditions may have been translated if We
                    have made them available to You on our Service. You agree
                    that the original English text shall prevail in the case of
                    a dispute.
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto  my-5">
                  <h5 className="mt-0">
                    Changes to These Terms and Conditions
                  </h5>
                  <p className="my-2">
                    We reserve the right, at Our sole discretion, to modify or
                    replace these Terms at any time. If a revision is material
                    We will make reasonable efforts to provide at least 30 days'
                    notice prior to any new terms taking effect. What
                    constitutes a material change will be determined at Our sole
                    discretion.
                  </p>
                  <p className="my-2">
                    By continuing to access or use Our Service after those
                    revisions become effective, You agree to be bound by the
                    revised terms. If You do not agree to the new terms, in
                    whole or in part, please stop using the website and the
                    Service.
                  </p>
                </div>
                <hr className={`${styles.hr}`} />
                <div className="col-11 col-lg-12 mx-auto  my-5">
                  <h5 className="mt-0">
                    {language === "en" ? "Contact Us" : "تواصل معنا"}
                  </h5>
                  <p className="my-2">
                    {language === "en"
                      ? `If you have any questions about these Terms and Conditions,
                  You can contact us:`
                      : ` إذا كان لديك أي أسئلة حول هذه الشروط والأحكام، يمكنك الاتصال بنا  `}
                  </p>
                  <p className="my-2 text-dark">
                    {language === "en"
                      ? "• By Email:"
                      : " • بالبريد الالكتروني:  "}{" "}
                    <Link to="mailto:info@nilecapitalcruises.com">
                      <span style={{ fontWeight: "400" }}>
                        info@nilecapitalcruises.com
                      </span>
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default TermsAndConditions;
